/**
 * The generated form-schema modules, loaded on demand. Keyed by file path (/src/forms/{module}/{Entity}Schema.ts);
 * each exports the form a generated detail view renders — {Entity}UpdateSchema, {Entity}UpdateUiSchema,
 * {Entity}UpdatePanels and {Entity}UpdatePageTabs among others.
 */
const schemaModules = import.meta.glob('/src/forms/**/*Schema.ts');

/** `module` as the page context or a lookup config names it: `Finance` or `finance`. */
const schemaModulePath = (module: string, entity: string) => `/src/forms/${module.toLowerCase()}/${entity}Schema.ts`;

/** Whether the entity has a generated form. */
export function hasFormSchemaModule(module: string, entity: string): boolean {
  return schemaModulePath(module, entity) in schemaModules;
}

/** The entity's generated form-schema module, or null for an entity without one (a custom-form entity). */
export async function loadFormSchemaModule(module: string, entity: string): Promise<Record<string, unknown> | null> {
  const loader = schemaModules[schemaModulePath(module, entity)];
  return loader ? ((await loader()) as Record<string, unknown>) : null;
}
